export default __webpack_public_path__ + "static/media/signin.be9d8c84.png";